import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import { selectors } from 'dux/user';

import ErrorPage from './ErrorPage';

const propTypes = {
  match: PropTypes.shape({}).isRequired,
  error: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  error: selectors.getSessionState(state).error,
});

const ErrorPageContainer = (props) => {
  const {
    match: {
      params: { statusCode },
    },
    error,
  } = props;
  return <ErrorPage errorStatusCode={statusCode} error={error} />;
};

ErrorPageContainer.propTypes = propTypes;

export default connect(mapStateToProps, null)(ErrorPageContainer);
